// src/index.ts
var userGenerated = ["css","pos","insetEnd","end","insetStart","start","flexDir","p","pl","pr","pt","pb","py","paddingY","paddingX","px","pe","paddingEnd","ps","paddingStart","ml","mr","mt","mb","m","my","marginY","mx","marginX","me","marginEnd","ms","marginStart","ringWidth","ringColor","ring","ringOffset","w","minW","maxW","h","minH","maxH","bgPosition","bgPositionX","bgPositionY","bgAttachment","bgClip","bg","bgColor","bgOrigin","bgImage","bgRepeat","bgBlendMode","bgSize","bgGradient","rounded","roundedTopLeft","roundedTopRight","roundedBottomRight","roundedBottomLeft","roundedTop","roundedRight","roundedBottom","roundedLeft","roundedStartStart","roundedStartEnd","roundedStart","roundedEndStart","roundedEndEnd","roundedEnd","borderX","borderXWidth","borderXColor","borderY","borderYWidth","borderYColor","borderStart","borderStartColor","borderEnd","borderEndColor","shadow","shadowColor","x","y","aspectRatio","boxDecorationBreak","zIndex","boxSizing","objectPosition","objectFit","overscrollBehavior","overscrollBehaviorX","overscrollBehaviorY","position","top","left","insetInline","insetBlock","inset","insetBlockEnd","insetBlockStart","insetInlineEnd","insetInlineStart","right","bottom","insetX","insetY","float","visibility","display","hideFrom","hideBelow","flexBasis","flex","flexDirection","flexGrow","flexShrink","gridTemplateColumns","gridTemplateRows","gridColumn","gridRow","gridColumnStart","gridColumnEnd","gridAutoFlow","gridAutoColumns","gridAutoRows","gap","gridGap","gridRowGap","gridColumnGap","rowGap","columnGap","justifyContent","alignContent","alignItems","alignSelf","padding","paddingLeft","paddingRight","paddingTop","paddingBottom","paddingBlock","paddingBlockEnd","paddingBlockStart","paddingInline","paddingInlineEnd","paddingInlineStart","marginLeft","marginRight","marginTop","marginBottom","margin","marginBlock","marginBlockEnd","marginBlockStart","marginInline","marginInlineEnd","marginInlineStart","outlineWidth","outlineColor","outline","outlineOffset","divideX","divideY","divideColor","divideStyle","width","inlineSize","minWidth","minInlineSize","maxWidth","maxInlineSize","height","blockSize","minHeight","minBlockSize","maxHeight","maxBlockSize","color","fontFamily","fontSize","fontWeight","fontSmoothing","fontVariantNumeric","letterSpacing","lineHeight","textAlign","textDecoration","textDecorationColor","textEmphasisColor","textDecorationStyle","textDecorationThickness","textUnderlineOffset","textTransform","textIndent","textShadow","textOverflow","verticalAlign","wordBreak","textWrap","truncate","lineClamp","listStyleType","listStylePosition","listStyleImage","backgroundPosition","backgroundPositionX","backgroundPositionY","backgroundAttachment","backgroundClip","background","backgroundColor","backgroundOrigin","backgroundImage","backgroundRepeat","backgroundBlendMode","backgroundSize","backgroundGradient","textGradient","gradientFrom","gradientTo","gradientVia","borderRadius","borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius","borderTopRadius","borderRightRadius","borderBottomRadius","borderLeftRadius","borderStartStartRadius","borderStartEndRadius","borderStartRadius","borderEndStartRadius","borderEndEndRadius","borderEndRadius","border","borderColor","borderInline","borderInlineWidth","borderInlineColor","borderBlock","borderBlockWidth","borderBlockColor","borderLeft","borderLeftColor","borderInlineStart","borderInlineStartColor","borderRight","borderRightColor","borderInlineEnd","borderInlineEndColor","borderTop","borderTopColor","borderBottom","borderBottomColor","borderBlockEnd","borderBlockEndColor","borderBlockStart","borderBlockStartColor","boxShadow","boxShadowColor","mixBlendMode","filter","brightness","contrast","grayscale","hueRotate","invert","saturate","sepia","dropShadow","blur","backdropFilter","backdropBlur","backdropBrightness","backdropContrast","backdropGrayscale","backdropHueRotate","backdropInvert","backdropOpacity","backdropSaturate","backdropSepia","borderCollapse","borderSpacing","borderSpacingX","borderSpacingY","tableLayout","transitionTimingFunction","transitionDelay","transitionDuration","transitionProperty","transition","animation","animationDelay","transformOrigin","scale","scaleX","scaleY","translate","translateX","translateY","accentColor","caretColor","scrollBehavior","scrollbar","scrollMargin","scrollMarginX","scrollMarginY","scrollMarginLeft","scrollMarginRight","scrollMarginTop","scrollMarginBottom","scrollMarginBlock","scrollMarginBlockEnd","scrollMarginBlockStart","scrollMarginInline","scrollMarginInlineEnd","scrollMarginInlineStart","scrollPadding","scrollPaddingBlock","scrollPaddingBlockStart","scrollPaddingBlockEnd","scrollPaddingInline","scrollPaddingInlineEnd","scrollPaddingInlineStart","scrollPaddingX","scrollPaddingY","scrollPaddingLeft","scrollPaddingRight","scrollPaddingTop","scrollPaddingBottom","scrollSnapAlign","scrollSnapStop","scrollSnapType","scrollSnapStrictness","scrollSnapMargin","scrollSnapMarginTop","scrollSnapMarginBottom","scrollSnapMarginLeft","scrollSnapMarginRight","touchAction","userSelect","fill","stroke","srOnly","debug","appearance","backfaceVisibility","clipPath","hyphens","mask","maskImage","maskSize","textSizeAdjust","colorPalette","textStyle","_hover","_focus","_focusWithin","_focusVisible","_disabled","_active","_visited","_target","_readOnly","_readWrite","_empty","_checked","_enabled","_expanded","_highlighted","_before","_after","_firstLetter","_firstLine","_marker","_selection","_file","_backdrop","_first","_last","_only","_even","_odd","_firstOfType","_lastOfType","_onlyOfType","_peerFocus","_peerHover","_peerActive","_peerFocusWithin","_peerFocusVisible","_peerDisabled","_peerChecked","_peerInvalid","_peerExpanded","_peerPlaceholderShown","_groupFocus","_groupHover","_groupActive","_groupFocusWithin","_groupFocusVisible","_groupDisabled","_groupChecked","_groupExpanded","_groupInvalid","_indeterminate","_required","_valid","_invalid","_autofill","_inRange","_outOfRange","_placeholder","_placeholderShown","_pressed","_selected","_default","_optional","_open","_fullscreen","_loading","_currentPage","_currentStep","_motionReduce","_motionSafe","_print","_landscape","_portrait","_dark","_light","_osDark","_osLight","_highContrast","_lessContrast","_moreContrast","_ltr","_rtl","_scrollbar","_scrollbarThumb","_scrollbarTrack","_horizontal","_vertical","_supportsBackdrop","sm","smOnly","smDown","md","mdOnly","mdDown","lg","lgOnly","lgDown","xl","xlOnly","xlDown","2xl","2xlOnly","smToMd","smToLg","smToXl","smTo2xl","mdToLg","mdToXl","mdTo2xl","lgToXl","lgTo2xl","xlTo2xl"];
var allCssProperties = [
  "MsAccelerator",
  "MsBlockProgression",
  "MsContentZoomChaining",
  "MsContentZooming",
  "MsContentZoomLimit",
  "MsContentZoomLimitMax",
  "MsContentZoomLimitMin",
  "MsContentZoomSnap",
  "MsContentZoomSnapPoints",
  "MsContentZoomSnapType",
  "MsFilter",
  "MsFlowFrom",
  "MsFlowInto",
  "MsGridColumns",
  "MsGridRows",
  "MsHighContrastAdjust",
  "MsHyphenateLimitChars",
  "MsHyphenateLimitLines",
  "MsHyphenateLimitZone",
  "MsImeAlign",
  "MsOverflowStyle",
  "MsScrollbar3dlightColor",
  "MsScrollbarArrowColor",
  "MsScrollbarBaseColor",
  "MsScrollbarDarkshadowColor",
  "MsScrollbarFaceColor",
  "MsScrollbarHighlightColor",
  "MsScrollbarShadowColor",
  "MsScrollbarTrackColor",
  "MsScrollChaining",
  "MsScrollLimit",
  "MsScrollLimitXMax",
  "MsScrollLimitXMin",
  "MsScrollLimitYMax",
  "MsScrollLimitYMin",
  "MsScrollRails",
  "MsScrollSnapPointsX",
  "MsScrollSnapPointsY",
  "MsScrollSnapType",
  "MsScrollSnapX",
  "MsScrollSnapY",
  "MsScrollTranslation",
  "MsTextAutospace",
  "MsTouchSelect",
  "MsUserSelect",
  "MsWrapFlow",
  "MsWrapMargin",
  "MsWrapThrough",
  "MozAppearance",
  "MozBinding",
  "MozBorderBottomColors",
  "MozBorderLeftColors",
  "MozBorderRightColors",
  "MozBorderTopColors",
  "MozContextProperties",
  "MozFloatEdge",
  "MozForceBrokenImageIcon",
  "MozImageRegion",
  "MozOrient",
  "MozOutlineRadius",
  "MozOutlineRadiusBottomleft",
  "MozOutlineRadiusBottomright",
  "MozOutlineRadiusTopleft",
  "MozOutlineRadiusTopright",
  "MozStackSizing",
  "MozTextBlink",
  "MozUserFocus",
  "MozUserInput",
  "MozUserModify",
  "MozWindowDragging",
  "MozWindowShadow",
  "WebkitAppearance",
  "WebkitBorderBefore",
  "WebkitBorderBeforeColor",
  "WebkitBorderBeforeStyle",
  "WebkitBorderBeforeWidth",
  "WebkitBoxReflect",
  "WebkitLineClamp",
  "WebkitMask",
  "WebkitMaskAttachment",
  "WebkitMaskClip",
  "WebkitMaskComposite",
  "WebkitMaskImage",
  "WebkitMaskOrigin",
  "WebkitMaskPosition",
  "WebkitMaskPositionX",
  "WebkitMaskPositionY",
  "WebkitMaskRepeat",
  "WebkitMaskRepeatX",
  "WebkitMaskRepeatY",
  "WebkitMaskSize",
  "WebkitOverflowScrolling",
  "WebkitTapHighlightColor",
  "WebkitTextFillColor",
  "WebkitTextStroke",
  "WebkitTextStrokeColor",
  "WebkitTextStrokeWidth",
  "WebkitTouchCallout",
  "WebkitUserModify",
  "accentColor",
  "alignContent",
  "alignItems",
  "alignSelf",
  "alignTracks",
  "all",
  "animation",
  "animationComposition",
  "animationDelay",
  "animationDirection",
  "animationDuration",
  "animationFillMode",
  "animationIterationCount",
  "animationName",
  "animationPlayState",
  "animationTimingFunction",
  "animationTimeline",
  "appearance",
  "aspectRatio",
  "azimuth",
  "backdropFilter",
  "backfaceVisibility",
  "background",
  "backgroundAttachment",
  "backgroundBlendMode",
  "backgroundClip",
  "backgroundColor",
  "backgroundImage",
  "backgroundOrigin",
  "backgroundPosition",
  "backgroundPositionX",
  "backgroundPositionY",
  "backgroundRepeat",
  "backgroundSize",
  "blockOverflow",
  "blockSize",
  "border",
  "borderBlock",
  "borderBlockColor",
  "borderBlockStyle",
  "borderBlockWidth",
  "borderBlockEnd",
  "borderBlockEndColor",
  "borderBlockEndStyle",
  "borderBlockEndWidth",
  "borderBlockStart",
  "borderBlockStartColor",
  "borderBlockStartStyle",
  "borderBlockStartWidth",
  "borderBottom",
  "borderBottomColor",
  "borderBottomLeftRadius",
  "borderBottomRightRadius",
  "borderBottomStyle",
  "borderBottomWidth",
  "borderCollapse",
  "borderColor",
  "borderEndEndRadius",
  "borderEndStartRadius",
  "borderImage",
  "borderImageOutset",
  "borderImageRepeat",
  "borderImageSlice",
  "borderImageSource",
  "borderImageWidth",
  "borderInline",
  "borderInlineEnd",
  "borderInlineColor",
  "borderInlineStyle",
  "borderInlineWidth",
  "borderInlineEndColor",
  "borderInlineEndStyle",
  "borderInlineEndWidth",
  "borderInlineStart",
  "borderInlineStartColor",
  "borderInlineStartStyle",
  "borderInlineStartWidth",
  "borderLeft",
  "borderLeftColor",
  "borderLeftStyle",
  "borderLeftWidth",
  "borderRadius",
  "borderRight",
  "borderRightColor",
  "borderRightStyle",
  "borderRightWidth",
  "borderSpacing",
  "borderStartEndRadius",
  "borderStartStartRadius",
  "borderStyle",
  "borderTop",
  "borderTopColor",
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderTopStyle",
  "borderTopWidth",
  "borderWidth",
  "bottom",
  "boxAlign",
  "boxDecorationBreak",
  "boxDirection",
  "boxFlex",
  "boxFlexGroup",
  "boxLines",
  "boxOrdinalGroup",
  "boxOrient",
  "boxPack",
  "boxShadow",
  "boxSizing",
  "breakAfter",
  "breakBefore",
  "breakInside",
  "captionSide",
  "caret",
  "caretColor",
  "caretShape",
  "clear",
  "clip",
  "clipPath",
  "color",
  "colorScheme",
  "columnCount",
  "columnFill",
  "columnGap",
  "columnRule",
  "columnRuleColor",
  "columnRuleStyle",
  "columnRuleWidth",
  "columnSpan",
  "columnWidth",
  "columns",
  "contain",
  "containIntrinsicSize",
  "containIntrinsicBlockSize",
  "containIntrinsicHeight",
  "containIntrinsicInlineSize",
  "containIntrinsicWidth",
  "container",
  "containerName",
  "containerType",
  "content",
  "contentVisibility",
  "counterIncrement",
  "counterReset",
  "counterSet",
  "cursor",
  "direction",
  "display",
  "emptyCells",
  "filter",
  "flex",
  "flexBasis",
  "flexDirection",
  "flexFlow",
  "flexGrow",
  "flexShrink",
  "flexWrap",
  "float",
  "font",
  "fontFamily",
  "fontFeatureSettings",
  "fontKerning",
  "fontLanguageOverride",
  "fontOpticalSizing",
  "fontPalette",
  "fontVariationSettings",
  "fontSize",
  "fontSizeAdjust",
  "fontSmooth",
  "fontStretch",
  "fontStyle",
  "fontSynthesis",
  "fontVariant",
  "fontVariantAlternates",
  "fontVariantCaps",
  "fontVariantEastAsian",
  "fontVariantEmoji",
  "fontVariantLigatures",
  "fontVariantNumeric",
  "fontVariantPosition",
  "fontWeight",
  "forcedColorAdjust",
  "gap",
  "grid",
  "gridArea",
  "gridAutoColumns",
  "gridAutoFlow",
  "gridAutoRows",
  "gridColumn",
  "gridColumnEnd",
  "gridColumnGap",
  "gridColumnStart",
  "gridGap",
  "gridRow",
  "gridRowEnd",
  "gridRowGap",
  "gridRowStart",
  "gridTemplate",
  "gridTemplateAreas",
  "gridTemplateColumns",
  "gridTemplateRows",
  "hangingPunctuation",
  "height",
  "hyphenateCharacter",
  "hyphenateLimitChars",
  "hyphens",
  "imageOrientation",
  "imageRendering",
  "imageResolution",
  "imeMode",
  "initialLetter",
  "initialLetterAlign",
  "inlineSize",
  "inputSecurity",
  "inset",
  "insetBlock",
  "insetBlockEnd",
  "insetBlockStart",
  "insetInline",
  "insetInlineEnd",
  "insetInlineStart",
  "isolation",
  "justifyContent",
  "justifyItems",
  "justifySelf",
  "justifyTracks",
  "left",
  "letterSpacing",
  "lineBreak",
  "lineClamp",
  "lineHeight",
  "lineHeightStep",
  "listStyle",
  "listStyleImage",
  "listStylePosition",
  "listStyleType",
  "margin",
  "marginBlock",
  "marginBlockEnd",
  "marginBlockStart",
  "marginBottom",
  "marginInline",
  "marginInlineEnd",
  "marginInlineStart",
  "marginLeft",
  "marginRight",
  "marginTop",
  "marginTrim",
  "mask",
  "maskBorder",
  "maskBorderMode",
  "maskBorderOutset",
  "maskBorderRepeat",
  "maskBorderSlice",
  "maskBorderSource",
  "maskBorderWidth",
  "maskClip",
  "maskComposite",
  "maskImage",
  "maskMode",
  "maskOrigin",
  "maskPosition",
  "maskRepeat",
  "maskSize",
  "maskType",
  "masonryAutoFlow",
  "mathDepth",
  "mathShift",
  "mathStyle",
  "maxBlockSize",
  "maxHeight",
  "maxInlineSize",
  "maxLines",
  "maxWidth",
  "minBlockSize",
  "minHeight",
  "minInlineSize",
  "minWidth",
  "mixBlendMode",
  "objectFit",
  "objectPosition",
  "offset",
  "offsetAnchor",
  "offsetDistance",
  "offsetPath",
  "offsetPosition",
  "offsetRotate",
  "opacity",
  "order",
  "orphans",
  "outline",
  "outlineColor",
  "outlineOffset",
  "outlineStyle",
  "outlineWidth",
  "overflow",
  "overflowAnchor",
  "overflowBlock",
  "overflowClipBox",
  "overflowClipMargin",
  "overflowInline",
  "overflowWrap",
  "overflowX",
  "overflowY",
  "overscrollBehavior",
  "overscrollBehaviorBlock",
  "overscrollBehaviorInline",
  "overscrollBehaviorX",
  "overscrollBehaviorY",
  "padding",
  "paddingBlock",
  "paddingBlockEnd",
  "paddingBlockStart",
  "paddingBottom",
  "paddingInline",
  "paddingInlineEnd",
  "paddingInlineStart",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  "page",
  "pageBreakAfter",
  "pageBreakBefore",
  "pageBreakInside",
  "paintOrder",
  "perspective",
  "perspectiveOrigin",
  "placeContent",
  "placeItems",
  "placeSelf",
  "pointerEvents",
  "position",
  "printColorAdjust",
  "quotes",
  "resize",
  "right",
  "rotate",
  "rowGap",
  "rubyAlign",
  "rubyMerge",
  "rubyPosition",
  "scale",
  "scrollbarColor",
  "scrollbarGutter",
  "scrollbarWidth",
  "scrollBehavior",
  "scrollMargin",
  "scrollMarginBlock",
  "scrollMarginBlockStart",
  "scrollMarginBlockEnd",
  "scrollMarginBottom",
  "scrollMarginInline",
  "scrollMarginInlineStart",
  "scrollMarginInlineEnd",
  "scrollMarginLeft",
  "scrollMarginRight",
  "scrollMarginTop",
  "scrollPadding",
  "scrollPaddingBlock",
  "scrollPaddingBlockStart",
  "scrollPaddingBlockEnd",
  "scrollPaddingBottom",
  "scrollPaddingInline",
  "scrollPaddingInlineStart",
  "scrollPaddingInlineEnd",
  "scrollPaddingLeft",
  "scrollPaddingRight",
  "scrollPaddingTop",
  "scrollSnapAlign",
  "scrollSnapCoordinate",
  "scrollSnapDestination",
  "scrollSnapPointsX",
  "scrollSnapPointsY",
  "scrollSnapStop",
  "scrollSnapType",
  "scrollSnapTypeX",
  "scrollSnapTypeY",
  "scrollTimeline",
  "scrollTimelineAxis",
  "scrollTimelineName",
  "shapeImageThreshold",
  "shapeMargin",
  "shapeOutside",
  "tabSize",
  "tableLayout",
  "textAlign",
  "textAlignLast",
  "textCombineUpright",
  "textDecoration",
  "textDecorationColor",
  "textDecorationLine",
  "textDecorationSkip",
  "textDecorationSkipInk",
  "textDecorationStyle",
  "textDecorationThickness",
  "textEmphasis",
  "textEmphasisColor",
  "textEmphasisPosition",
  "textEmphasisStyle",
  "textIndent",
  "textJustify",
  "textOrientation",
  "textOverflow",
  "textRendering",
  "textShadow",
  "textSizeAdjust",
  "textTransform",
  "textUnderlineOffset",
  "textUnderlinePosition",
  "top",
  "touchAction",
  "transform",
  "transformBox",
  "transformOrigin",
  "transformStyle",
  "transition",
  "transitionDelay",
  "transitionDuration",
  "transitionProperty",
  "transitionTimingFunction",
  "translate",
  "unicodeBidi",
  "userSelect",
  "verticalAlign",
  "viewTransitionName",
  "visibility",
  "whiteSpace",
  "widows",
  "width",
  "willChange",
  "wordBreak",
  "wordSpacing",
  "wordWrap",
  "writingMode",
  "zIndex",
  "zoom",
  ...userGenerated
];
var properties = new Map(allCssProperties.map((prop) => [prop, true]));
function memo(fn) {
  const cache = /* @__PURE__ */ Object.create(null);
  return (arg) => {
    if (cache[arg] === void 0)
      cache[arg] = fn(arg);
    return cache[arg];
  };
}
var selectorRegex = /&|@/;
var isCssProperty = memo((prop) => {
  return properties.has(prop) || prop.startsWith("--") || selectorRegex.test(prop);
});
export {
  allCssProperties,
  isCssProperty
};
